import axios from "axios"

const API_URL = process.env.NODE_ENV !== 'production' ?  "https://mgl:8890/api/" : 'https://test-api.icnt.ba/api/';
export const ASSETS_URL = process.env.NODE_ENV !== 'production' ?  "https://mgl:8890/assets/" : 'https://test-api.icnt.ba/assets/';

const protectedApi = axios.create({
    baseURL: API_URL
});

const getCookieValue = (cookieName: any) => {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].split('=');
      if (cookie[0] === cookieName) {
        return decodeURIComponent(cookie[1]);
      }
    }
    return null;
  }

protectedApi.interceptors.request.use(
    config => {
        config.headers['Authorization'] = `Bearer ${getCookieValue("token")}`;
        return config;
    }
)

protectedApi.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        if (error.response) {
            if(error.response.status === 401) {
                const refreshToken = getCookieValue("refreshToken");
                try {
                    const response = await postRefresh({refreshToken: refreshToken});

                    if (response) {
                        document.cookie = `token=${response.token}; max-age=${6*60}; Secure; path=/`;
                        document.cookie = `refreshToken=${response.refreshToken}; max-age=${12*60}; Secure; path=/`;
                    }

                } catch (error: any) {
                    if(error.response.status === 404) {
                        let currentUrl = window.location.href;
                        window.location.replace(`/login?returnUrl=${currentUrl}`);
                        document.cookie = `token=; max-age=${0}; Secure; path=/`;
                        document.cookie = `refreshToken=; max-age=${0}; Secure; path=/`;
                    }
                }


                try {

                    /* //prevent multiple token refresh API calls
                    if (postRefreshTokenInProgress == false) { 
                        postRefreshTokenInProgress = true

                        //prevent multiple tabs refresh API calls
                        navigator.locks.request("refresh_jwt_token", async (lock) => {
                            // The lock has been acquired.
                            const res = await postRefreshToken(data)
                            .then((response) => {
                                console.log("response", response);

                                const {jwtToken, refreshToken} = response;

                                window.localStorage.setItem("token", jwtToken);
                                window.localStorage.setItem("refreshToken", refreshToken);

                                postRefreshTokenInProgress = false;
                            }).catch((response) => {
                                console.log("refresh JWT token error", response);

                                // 404 means that user should be loged out
                                if (response.response.status == 404) {
                                    let currentUrl = window.location.href;
                                    window.location.replace(`/login?returnUrl=${currentUrl}`);
                                    window.localStorage.clear();
                                }

                                postRefreshTokenInProgress = false;
                            });
                            
                            // Now the lock will be released.
                        });
                    } */
                    
                } catch {
                    /* let currentUrl = window.location.href;
                    window.location.replace(`/login?returnUrl=${currentUrl}`);
                    window.localStorage.clear(); */
                }
            }

            if (error.response.status !== 401) {
                if(error.response.status === 500) {
                    // window.location.replace("/login");
                }
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
)

//POST
export const postLogin = async (payload: any) => {
    const res = await axios.post(API_URL + `login/read.php`, payload, { withCredentials: true });
    return res.data;
}

export const postRefresh = async (payload: any) => {
    const res = await axios.post(API_URL + `login/refresh.php`, payload, { withCredentials: true });
    return res.data;
}

export const postLogout = async () => {
    const res = await protectedApi.post(API_URL + `authentication/logout`, {}, { withCredentials: true });
    return res.data;
}

export const postArticleCreate = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `articles/create.php`, payload, { withCredentials: true });
    return res.data;
}

export const postArticleUpdate = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `articles/update.php`, payload, { withCredentials: true });
    return res.data;
}

export const postArticleMainPhoto = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `articles/createMainPhotoConnection.php`, payload, { withCredentials: true });
    return res.data;
}

export const postPhotos = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `photos/create.php`, payload, { withCredentials: true });
    return res.data;
}

export const postPhotosSearch = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `photos/search.php`, payload, { withCredentials: true });
    return res.data;
}

export const postTranslationCreate = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `placeholders/create.php`, payload, { withCredentials: true });
    return res.data;
}

export const postTranslationUpdate = async (payload: any) => {
    const res = await protectedApi.post(API_URL + `placeholders/update.php`, payload, { withCredentials: true });
    return res.data;
}

export const getArticle = async (id: any) => {
    const res = await protectedApi.get(API_URL + `articles/readById.php?id=${id}`, { withCredentials: true });
    return res.data;
}

export const getArticles = async () => {
    const res = await protectedApi.get(API_URL + `articles/read.php`, { withCredentials: true });
    return res.data;
}

export const getArticlesConnectedPhotos = async (id: any) => {
    const res = await protectedApi.get(API_URL + `articles/readConnectedPhotos.php?itemId=${id}`, { withCredentials: true });
    return res.data;
}

export const getLanguages = async () => {
    const res = await protectedApi.get(API_URL + `languages/read.php`, { withCredentials: true });
    return res.data;
}

export const getPhotos = async () => {
    const res = await protectedApi.get(API_URL + `photos/read.php`, { withCredentials: true });
    return res.data;
}

export const getMessage = async (id: number) => {
    const res = await protectedApi.get(API_URL + `contacts/read.php?id=${id}`, { withCredentials: true });
    return res.data;
}

export const getMessages = async () => {
    const res = await protectedApi.get(API_URL + `contacts/readAll.php`, { withCredentials: true });
    return res.data;
}

export const getTranslations = async () => {
    const res = await protectedApi.get(API_URL + `placeholders/read.php`, { withCredentials: true });
    return res.data;
}

export const getTranslation = async (id: any) => {
    const res = await protectedApi.get(API_URL + `placeholders/readById.php?id=${id}`, { withCredentials: true });
    return res.data;
}

export const deleteArticle = async (payload: any) => {
    const res = await protectedApi.delete(API_URL + `articles/delete.php`, {data: payload, withCredentials: true });
    return res.data;
}

export const deleteConnectedPhoto = async (payload: any) => {
    const res = await protectedApi.delete(API_URL + `articles/deleteConnectedPhoto.php`, {data: payload, withCredentials: true });
    return res.data;
}

export const deletePhoto = async (payload: any) => {
    const res = await protectedApi.delete(API_URL + `photos/delete.php`, {data: payload, withCredentials: true });
    return res.data;
}

export const deletePlaceholder = async (payload: any) => {
    const res = await protectedApi.delete(API_URL + `placeholders/delete.php`, {data: payload, withCredentials: true });
    return res.data;
}

//PUT
export const putStarRating = async (payload: any) => {
    const res = await protectedApi.put(API_URL + `application/starrating`, payload, { withCredentials: true });
    return res.data;
}

export const putArticlePhotoConnect = async (payload: any) => {
    const res = await protectedApi.put(API_URL + `articles/createConnectionPhotos.php`, payload, { withCredentials: true });
    return res.data;
}